import { get } from './utils';

const getAffiliateEmbedDashboardUrl = async (): Promise<{ url: string }> =>
  await get('/analytics/get-affiliate-embed-dashboard-url');

export const analytics = {
  getAffiliateEmbedDashboardUrl
};
